import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getFeaturedServices, getCategoryById } from '@/lib/content';

export default function FocusCarousel() {
  const slides = getFeaturedServices();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  if (slides.length === 0) return null;

  const go = (dir: number) => {
    setIndex((prev) => (prev + dir + slides.length) % slides.length);
  };

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 text-xl">
            <i className="ri-slideshow-3-line"></i>
          </span>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">焦点推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">本周主打的教育、娱乐、购物等精选服务</p>
          </div>
        </div>
      </div>

      <div className="relative rounded-lg overflow-hidden h-[300px] md:h-[380px] bg-primary-950">
        {slides.map((slide, i) => {
          const category = getCategoryById(slide.categoryId);
          return (
            <div
              key={slide.id}
              className={`absolute inset-0 transition-opacity duration-700 ${
                i === index ? 'opacity-100 z-10' : 'opacity-0 z-0'
              }`}
            >
              <img
                src={slide.image}
                alt={slide.title}
                title={`${slide.title} - 在线精选推荐`}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/70 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-14 max-w-2xl">
                <span className="inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs mb-4">
                  <i className="ri-fire-line"></i>
                  {category?.name} · 精选推荐
                </span>
                <h3 className="text-xl md:text-3xl font-bold text-background-50 leading-snug">{slide.title}</h3>
                <p className="mt-3 text-sm md:text-base text-primary-100 line-clamp-2">{slide.summary}</p>
                <Link
                  to={`/detail/${slide.id}`}
                  className="mt-6 inline-flex w-fit items-center gap-2 px-5 py-2.5 text-sm rounded-md bg-background-50 text-primary-700 font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看详情
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          );
        })}

        <button
          type="button"
          onClick={() => go(-1)}
          aria-label="上一张"
          className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          onClick={() => go(1)}
          aria-label="下一张"
          className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>

        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第 ${i + 1} 张`}
              onClick={() => setIndex(i)}
              className={`h-2 rounded-full transition-all cursor-pointer ${
                i === index ? 'w-6 bg-accent-500' : 'w-2 bg-background-50/50'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}